import { StyleSheet } from "react-native";

export default StyleSheet.create({
    screenContainer: {
        flex: 1,
        flexDirection: "column",
    },
    screenContent: {
        width: "100%",
        flexGrow: 1,
        //paddingBottom: 20,
        justifyContent: "center",
    },
    screenScrollContent: {
        paddingBottom: 20,
        paddingHorizontal: 25,
    },
    screenTitle: {
        fontSize: 30,
        fontWeight: "bold",
        marginBottom: 20,
    },
    screenDescription: {
        fontSize: 17,
        marginVertical: 20,
    },
    screenText: {
        marginTop: 10,
        marginBottom: 20,
    },
    screenActions: {
        position: "absolute",
        alignContent: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        bottom: 0,
        alignItems: "center",
    },
    screenButton: {
        width: "100%",
    },
    screenActionsBackground: {
        position: "absolute",
        height: "100%",
        width: "100%",
    },
    screenErrorMessage: {
        color: "blue",
        fontSize: 17,
        textAlign: "center",
        marginVertical: 20,
    },
    screenInput: {},
    progressHeader: {
        height: 80,
        width: "100%",
        flexDirection: "row",
        justifyContent: "flex-start",
    },
    progressHeaderImage: {
        width: "100%",
    },
});
